const METADATA_ELEMENT_ID_SEPARATOR = '_' as const;

export const getFullMetadataElementId = (metadataElement: {
  metadataId: string;
  orgId: string;
}) => {
  return `${metadataElement.orgId}${METADATA_ELEMENT_ID_SEPARATOR}${metadataElement.metadataId}`;
};

export const getOrgTypeFromMetadataId = (metadataId: string): string =>
  metadataId.split('.')[0];
